import React from "react"

import { AppModuleEbook } from "@treefort/api-spec"

import { EbookModule } from "../../../../components/modules/ebook"
import { ListViewModule, ItemArgs } from "../list-view-module"

type Item = AppModuleEbook["config"]

export class EbookListViewModule
  implements ListViewModule<AppModuleEbook, Item>
{
  readonly appModule: AppModuleEbook
  readonly appHeaderPresentation = undefined
  readonly appHeaderState = undefined
  readonly gapSize = 36
  readonly maxWidth = 1200

  constructor(appModule: AppModuleEbook) {
    this.appModule = appModule
  }

  getItems = () => [this.appModule.config]

  renderItem = (args: ItemArgs<Item>) => (
    <EbookModule
      {...args.item}
      paddingTop={args.safeAreaInsets.top}
      maxWidth={args.maxWidth}
      presentation={args.itemCount > 1 ? "listItem" : "solo"}
    />
  )

  getItemKey = ({ pageKey, indexInPage }: ItemArgs<Item>) =>
    pageKey + indexInPage + this.appModule.id
}
